document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {
        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;
    });

    let sliderText = new Swiper('.text_slider', {
        slidesPerView: 1,
        speed: 700,
        effect: "fade",
        loop: true,
        autoHeight: true,
        allowTouchMove: false,
        fadeEffect: {
            "crossFade": true
        },
        navigation: {
            nextEl: ".slider-block .arrow-next",
            prevEl: ".slider-block .arrow-prev",
        },
        pagination: {
            el: ".slider-block .swiper-pagination",
            clickable: true
        },
        breakpoints: {
            900: {
                allowTouchMove: true
            }
        }
    });

    let sliderImages = new Swiper('.images_slider', {
        slidesPerView: 1.1,
        speed: 700,
        loop: true,
        spaceBetween:10,
        allowTouchMove: true,
        touchRatio: 1,
        touchStartPreventDefault: false,
        navigation: {
            nextEl: ".slider-block .arrow-next",
            prevEl: ".slider-block .arrow-prev",
        },
        pagination: {
            el: ".slider-block .swiper-pagination",
            clickable: true
        },
        breakpoints: {
            900: {
                slidesPerView: 'auto',
                spaceBetween: 30
            }
        }
    });

    // if(window.innerWidth < 600){
    //     sliderImages.controller.control = sliderText;
    // }else{
    //     console.log('Hola Wilmar');
    //     sliderText.controller.control = sliderImages;
    // }    

    if(sliderImages && windowWidth < 600){
        sliderImages.on('slideChange', function () {
            let moveTo = this.realIndex;
            moveTo = this.realIndex + 1;

            if(moveTo >= this.slidesGrid.length){
                moveTo = 0;
            }    
            
            sliderText.slideTo(moveTo);
            sliderText.update();
        });
    }
});